export const UPDATE_FONTSIZE = 'UPDATE_FONTSIZE'
export const DEFAULT_FONTSIZE = 'DEFAULT_FONTSIZE'

export const updateFontSize = value => ({ type: UPDATE_FONTSIZE, value })
export const defaultFontSize = () => ({ type: DEFAULT_FONTSIZE })